/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import WarehouseSyncModel, { WarehouseSyncExportFile } from 'cio/models/warehouse-sync';
import {
  WAREHOUSE_SCHEMA_V1_OPTIONS,
  WAREHOUSE_SCHEMA_V2_V3_SUPPORTED_OPTIONS,
  WAREHOUSE_SCHEMA_V4_OPTIONS,
  WarehouseDataOption,
  WarehouseDataOptionID,
} from 'cio/utils/warehouse';
import moment from 'moment-timezone';

const PEOPLE_SYNC_CUTOFF = 7;
const PEOPLE_SYNC_CUTOFF_WARN = 3;

interface WarehouseSyncDetailsRowArgs {
  model: WarehouseSyncModel;
  option: WarehouseDataOption;
  isActive: boolean;
  toggleSchemaVersionUpdateModal: () => unknown;
}

export default class WarehouseSyncDetailsRow extends Component<WarehouseSyncDetailsRowArgs> {
  get needsSchemaUpdate() {
    if (this.args.model.version === 1) {
      // If this row is present in v4, but not in v1, then it needs a schema update.
      let diff = WAREHOUSE_SCHEMA_V4_OPTIONS.filter((option) => !WAREHOUSE_SCHEMA_V1_OPTIONS.includes(option));
      return diff.includes(this.args.option);
    }

    if (this.args.model.version < 4) {
      // subjects and outputs should be disabled for toggling if version is 2 or 3
      let diff = WAREHOUSE_SCHEMA_V4_OPTIONS.filter(
        (option) => !WAREHOUSE_SCHEMA_V2_V3_SUPPORTED_OPTIONS.includes(option),
      );
      return diff.includes(this.args.option);
    }

    return false;
  }

  get latestExportFile(): WarehouseSyncExportFile | undefined {
    return this.args.model.exportFiles.find((file) => file.fileName.includes(this.args.option.id));
  }

  get peopleSyncAndDisabled() {
    return (
      this.args.option.id === WarehouseDataOptionID.people && this.daysSincePeopleSyncUpdated >= PEOPLE_SYNC_CUTOFF
    );
  }

  get peopleSyncAndCloseToDisabled() {
    return (
      this.args.option.id === WarehouseDataOptionID.people &&
      this.daysSincePeopleSyncUpdated >= PEOPLE_SYNC_CUTOFF_WARN &&
      this.daysSincePeopleSyncUpdated < PEOPLE_SYNC_CUTOFF
    );
  }

  get daysBeforePeopleSyncDisabled() {
    return PEOPLE_SYNC_CUTOFF - this.daysSincePeopleSyncUpdated;
  }

  private get daysSincePeopleSyncUpdated() {
    return moment().diff(moment.unix(this.args.model.peopleLastUpdatedAt), 'day');
  }
}
